<template>
  <div>
    <q-card class="full-width q-pb-md">
      <q-scroll-area
        :thumb-style="{
          background: '#162c479c',
          opacity: 1,
          width: '8px',
          height: '8px',
          borderRadius: '20px',
        }"
        style="height: 100vh"
      >
        <q-card-actions class="text-white q-pa-md green-background">
          <div class="title">{{ sourceName }}</div>
          <q-space></q-space>
          <q-btn
            color="primary"
            style="width: 100px"
            class="q-mr-sm sustainability-button"
            @click="save"
          >
            Save
          </q-btn>
          <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
        </q-card-actions>
        <q-card-section>
          <q-form ref="form" class="form-width">
            <div class="row items-stretch q-px-xl">
              <div class="col-12 q-px-sm">
                <q-input
                  type="textarea"
                  label="Notes"
                  v-model="notes"
                  :rules="[
                    (val) => (val && val.length > 0) || 'Please type something',
                  ]"
                >
                </q-input>
              </div>
            </div>
          </q-form>
        </q-card-section>
      </q-scroll-area>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      newData: {
        type: Boolean,
        default: false,
      },
      sourceName: {
        type: String,
        default: "Data",
      },
      sourceId: {
        type: Number,
      },
    },
    computed: {
      ...mapGetters({
        selectedSourceData: "sources/selectedSourceData",
      }),
    },
    watch: {
      selectedSourceData(value) {
        if (value) {
          this.notes = value.notes;
        }
      },
    },
    data: () => ({
      notes: "",
    }),
    methods: {
      closeDialog() {
        this.$store.commit("sources/setSelectedSourceData", null);
        this.$emit("closeDialog");
      },
      async save() {
        const isValid = await this.$refs.form.validate();
        let result = null;
        if (isValid) {
          if (this.newData) {
            result = await this.$store.dispatch("sources/newSourcesData", {
              notes: this.notes,
              sources_id: this.sourceId,
            });
          } else {
            result = await this.$store.dispatch("sources/saveSourcesData", {
              id: this.selectedSourceData.id,
              notes: this.notes,
              sources_id: this.sourceId,
            });
          }
          this.$store.dispatch("outcomes/loadAllOutcomesSources");
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
          this.closeDialog();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 13px;
  }

  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .green-background {
    background-color: #3e6259;
  }
</style>
